/**
 * String Control Component
 * Renders text input or textarea based on settings
 */

import React from 'react';
import { Box } from '@mui/material';
import { ControlComponentProps } from '../../../../types/ControlTypes';
import { StringSettings } from '../../../../types/ControlTypes';
import { BaseTextField } from '../BaseTextField';
import { LabelWithInfo } from './LabelWithInfo';

export const StringControl: React.FC<ControlComponentProps> = ({
  name,
  value,
  onChange,
  error,
  disabled,
  readonly,
  label,
  placeholder,
  description,
  required,
  control,
}) => {
  const settings = control.settings as StringSettings;
  const isMultiline = settings?.multiline || false;
  const rows = settings?.rows || (isMultiline ? 4 : 1);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onChange(e.target.value);
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ mb: 1 }}>
        <LabelWithInfo
          label={label || name}
          description={description || settings?.placeholder}
          required={required}
        />
      </Box>
      <BaseTextField
        type={isMultiline ? 'text' : 'text'}
        value={typeof value === 'string' ? value : ''}
        onChange={handleChange}
        placeholder={placeholder || settings?.placeholder}
        size="small"
        fullWidth
        multiline={isMultiline}
        rows={rows}
        disabled={disabled || readonly}
        error={!!error}
        helperText={error || (settings?.maxLength ? `${(value || '').length}/${settings.maxLength}` : '')}
        inputProps={{
          maxLength: settings?.maxLength,
          minLength: settings?.minLength,
          pattern: settings?.pattern,
        }}
      />
    </Box>
  );
};

export default StringControl;
